<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-list-alt"></i>
          Site
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WMDS</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">Site</a>
          </li>
      </ul>
    </div>
    <b-card>
      <!-- <template slot="header"><i class='fa fa-align-justify'></i>Site List</template> -->
      <!-- detail search start -->
      <b-card v-show="so.adv">
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="opt_date"> Registed Date
                <b-button size="sm" variant="info" @click="set_sd('', 'created_at')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d', 'created_at')">-1D</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w', 'created_at')">-1W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m', 'created_at')">-1M</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w', 'created_at')">W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m', 'created_at')">M</b-button>
              </label>
              <b-form inline>
                <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label for="opt_visit"> Last Visit
                <b-button size="sm" variant="info" @click="set_sd('', 'last_visit')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d', 'last_visit')">-1D</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w', 'last_visit')">-1W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m', 'last_visit')">-1M</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w', 'last_visit')">W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m', 'last_visit')">M</b-button>
              </label>
              <b-form inline>
                <date-picker @change="refresh" v-model="so.opt.last_visit_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.last_visit_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="opt_name">Name</label>
              <b-form-input @keydown.enter="refresh" type="text" id="opt_name" v-model="so.opt['name']"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label for="opt_FQDN">FQDN(URL)</label>
              <b-form-input @keydown.enter="refresh" type="text" id="opt_FQDN" v-model="so.opt['fqdn']"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4">
            <b-form-group>
              <label for="opt_status">Status</label>
              <br>
              <c-switch color="info" @change="refresh" label size="sm" v-model="so.opt['is_alive']" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <label for="ph_search_opt_type">Match Type</label>
            <b-form-group>
              <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" name="ph_search_opt_type">
                <b-form-radio value="and">[AND]:Match all</b-form-radio>
                <b-form-radio value="or">[OR]:Match at least one</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-form-group class="float-right">
          <b-button class="btn-addition" size="sm" variant="success" @click="refresh"> Search </b-button>
          <b-button size="sm" variant="warning" @click="reset"> Reset </b-button>
          <b-button size="sm" variant="secondary" @click="search_opt"> Close </b-button>
        </b-form-group>
      </b-card>
      <!-- detail search end -->

        <b-row>
          <b-col sm="6">
            <span class="text-center" v-b-tooltip.hover title="Specify the number of views on one page">
              Show Count
              <select v-model="so.perPage" @change="refresh">
                <option value="15">Default 15</option>
                <option value=10>10</option>
                <option value=50>50</option>
                <option value=100>100</option>
              </select>
            </span>
          </b-col>
          <b-col sm="6">
            <b-input-group size="sm">
              <b-input-group-prepend>
                <b-btn :disabled="so.adv" variant="outline-secondary" @click="refresh()"><i class="fa fa-refresh"></i></b-btn>
                <b-btn :disabled="so.adv" variant="outline-secondary" @click="reset()"><i class="fa fa-remove"></i></b-btn>
                <b-dropdown :disabled="so.adv" :text="so.skt || 'search'" size="sm" variant="outline-secondary">
                  <b-dropdown-item size="sm" @click="so.sk='fqdn'; so.skt='FQDN'">FQDN</b-dropdown-item>
                  <b-dropdown-item size="sm" @click="so.sk='name'; so.skt='name'">Name</b-dropdown-item>
                </b-dropdown>
              </b-input-group-prepend>
              <b-form-input :disabled="so.adv" v-model="so.sv" @keyup.native.enter="refresh"></b-form-input>
              <b-input-group-append>
                <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-search"></i></b-btn>
                <b-btn variant="outline-secondary" @click="search_opt"><i class="fa" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"> Detail Search</i></b-btn>
              </b-input-group-append>
            </b-input-group>
          </b-col>
        </b-row>
        <hr>
        <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found" class="table-responsive table_add"
          :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk">
          <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
          <template slot="is_alive" slot-scope="row">
            <c-switch color="info" label size="sm" v-model="row.item.is_alive" @change="toggle_index = row.index; status_toggle_modal(row.index, row.item.is_alive)" />
          </template>
          <template slot="name" slot-scope="row">
            <del v-if="row.item.is_del">{{row.item.name}}</del>
            <template v-else>{{row.item.name}}</template>
          </template>
          <template slot="fqdn" slot-scope="row">
            <a href="javascript:void(0)" class="a_tag" @click="detail(row.item.id)">
              {{row.item.fqdn}}
            </a>

          </template>
          <template slot="last_visit" slot-scope="row">{{row.item.last_visit | sdate}}</template>
          <!-- <template slot="func" slot-scope="row">
            <b-btn @click="detail(row.item.id)" size="sm" variant="outline-primary">More</b-btn>
          </template> -->
        </b-table>
        <hr>
        <b-row>
          <b-col md="3">
          </b-col>
          <b-col md="5">
            <b-pagination size="sm"  align="center":limit="10" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" prev-text="<" next-text=">" />
          </b-col>
          <b-col md="4">
            <div class="pull-right">
              <!-- 디버깅용 -->
              <!-- <b-button class="mr-2" size="sm" variant="outline-warning" @click="deleteAll"> DELETEALL_SCHEDULE </b-button> -->
              <b-button v-if="enable_new != false" class="mr-2" size="sm" variant="outline-warning" @click="upload"> Upload Multi Site </b-button>
              <b-button v-if="sites.length > 0 && enable_new != false" size="sm" variant="outline-primary" @click="$parent.$emit('count', 0); check_policy()">Quick Setup Guide </b-button>
              <b-button v-if="enable_new != false" class="mr-2 btn-add" size="sm" variant="success" @click="check_policy"> New registration </b-button>
            </div>
          </b-col>
        </b-row>
      </b-card>
    <router-view @hide-parent="hideList($event)" @refresh="refresh()"></router-view>
    <b-modal title="Usage Status Change"  class="modal-danger" no-close-on-backdrop v-model="toggle_confirm" hide-footer @ok="status_toggle_api" ok-variant="danger" header-variant="danger">
      <div class="d-block text-center">
        <h3>Are you change status to monitoring the site ?</h3>
        <hr>
        <h5>This change of setting affects billing</h5>
      </div>
      <hr>
      <b-button class="mt-2" variant="outline-warning" block @click="status_toggle_api">Appy</b-button>
      <b-button class="mt-3" variant="outline-danger" block @click="status_toggle_modal(-1, false)">Close</b-button>
    </b-modal>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
